import { useGetImplementQuery } from 'app/api';
import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useGetRoutesWithoutTaskFromState } from 'app/containers/Task/pages/RoutesWithoutTaskPage/hooks/useGetRoutesWithoutTaskFromState';
import { RoutesTableItemType } from 'app/containers/Task/slice/types';
import { useSelector } from 'react-redux';
import { useRouteCheck } from '../../../../../../../components/RouteListCards/RoutesWithoutTaskListCard/hooks/useRouteCheck';
import {
  getDefaultImplementIds,
  groupSameTransportWithImplementRoutes,
} from '../AddRouteToTaskDrawer.helpers';
import moment from 'moment';

export const useGetRoutesTableItems = () => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);
  const companyId = useSelector(selectSelectedCompanyId);

  const { routes } = useGetRoutesWithoutTaskFromState();

  const { checkedRoutes } = useRouteCheck({ routes });

  const { data: implementResponse } = useGetImplementQuery({
    companyId,
    companyGroupId,
    envId,
    pageSize: 1000,
    currentPage: 0,
    filters: {},
    sort: {},
  });

  const fromDates = checkedRoutes.map(route => new Date(route.from));
  const toDates = checkedRoutes.map(route => new Date(route.to));

  const maxToDate = moment(Math.max.apply(null, toDates as any)).format(
    'YYYY-MM-DD',
  );
  const minFromDate = moment(Math.min.apply(null, fromDates as any)).format(
    'YYYY-MM-DD',
  );

  const routeTableItems: RoutesTableItemType[] = [...checkedRoutes].map(
    checkedRoute => {
      return {
        id: checkedRoute.id,
        routeIds: [checkedRoute.id],
        gpsTransportId: checkedRoute.gpsVehicle.id,
        model: checkedRoute.gpsVehicle.licensePlate,
        beaconId: checkedRoute.beaconId,
        slimId: checkedRoute.slimId,
        startDate: checkedRoute.from,
        endDate: checkedRoute.to,
        distance: checkedRoute.distance,
        fieldSeasonIds: [checkedRoute.fieldSeasonId],
        area: null,
      };
    },
  );

  const groupedRoutes = groupSameTransportWithImplementRoutes(routeTableItems);

  const routesWithInitiallySelectedImplement = getDefaultImplementIds({
    groupedRoutes,
    implementArray: implementResponse?.content,
  });

  return {
    routeTableItems,
    groupedRoutes,
    routesWithInitiallySelectedImplement,
    minFromDate,
    maxToDate,
  };
};
